// Import packages
import React, {Component} from "react";
import {connect} from "react-redux";
import Nestable from "react-nestable";


// Import utils
import {mapStateToProps} from "../../../redux/mapStateToProps";
import {
    GetPartners,
    DeletePartnerById,
} from "../../../redux/actions";

// Import components
import {NestableItem} from "../../../components/cards/nestableItem";
import {deleteItem} from "../../../utils/helperFunctions";


class Partners extends Component {
    constructor(props) {
        super(props);
        this.deleteOfferItem = this.deleteOfferItem.bind(this);
    }

    componentDidMount() {
        this.props.GetPartners();
    }

    deleteOfferItem(id){
        this.props.DeletePartnerById(id)
    }

    getNestableItems(list, parent = null) {
        const items = [];
        list && !!list.length && list.forEach((item, index) => {
            const title = item?.title || '';

            items.push({
                id: item.id,
                index: index,
                title: title,
                withImage: true,
                path: item?.image_url,
                isHidden: item.is_hidden,
                link: {
                    pathname: `items/edit/${item.id}`,
                },
                deleteCb: deleteItem.bind(this, this.deleteOfferItem, 'գործընկերոջը', item.id),
                children: []
            })
        });
        return items;
    }


    render() {
        let {partnersList} = this.props;
        let items = this.getNestableItems(partnersList);
        return <>
            {items && items.length !== 0 &&
            <Nestable
                items={items}
                maxDepth={1}
                handler={()=>{}}
                onChange={this.onPositionChange}
                renderItem={NestableItem}
            />}
        </>
    }
}

const mapDispatchToProps = {
    GetPartners,
    DeletePartnerById,
};

export default connect(mapStateToProps, mapDispatchToProps)(Partners);
